module.exports = __webpack_public_path__ + "img/app_2.546385fd.png";